// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import * as tab0 from '/home/runner/work/dumi-theme-chakra/dumi-theme-chakra/example/src/Button/index.$tab-api.md';

export const tabs = {
  'src/Button/index.$tab-api': { key: 'api', title: '', titleIntlId: '', components: tab0 },
}
